import React, { useState } from 'react';
import { useAuth } from '../../Common/Configurations/AuthContext'; // Keeping your auth hook

const TemplateHeader2 = () => {
  // Getting user and logo from your AuthContext, as requested
  const { user } = useAuth();
  const logoUrl = user?.logo || 'https://via.placeholder.com/150x40?text=Your+Logo';
  
  // Using the navLinks from your original code
  const navLinks = ['Home', 'Destinations', 'Packages', 'About Us', 'Reviews', 'Contact'];

  // State to track the active link, defaulting to 'Home'
  const [activeLink, setActiveLink] = useState('Home');

  const styles = {
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between', // This arranges items: logo (left), menu (center), button (right)
      backgroundColor: 'var(--header-bg-color, #ffffff)',
      borderTop: '4px solid #000000',
      padding: '0 2rem', // Side padding
      height: '80px',    // Header height
      boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
      fontFamily: 'sans-serif', // A clean, modern font
    },
    logo: {
      height: '45px', // A slightly larger logo
    },
    nav: {
      // The nav element will be in the center due to 'space-between' on the header
    },
    navList: {
      display: 'flex',
      listStyle: 'none',
      margin: 0,
      padding: 0,
      height: '100%',
    },
    navItem: {
      display: 'flex',
      alignItems: 'center',
      height: '80px', // Match header height for the yellow block effect
      cursor: 'pointer',
    },
    navLink: {
      padding: '0 1.5rem', // Space between menu items
      textDecoration: 'none',
      textTransform: 'uppercase',
      color: 'var(--header-text-color, #000000)',
      fontWeight: 'bold',
      fontSize: '0.9rem',
      display: 'flex',
      alignItems: 'center',
      height: '100%',
    },
    activeNavItem: {
      backgroundColor: '#fecb00', // The yellow highlight color from the image
    },
    bookNowButton: {
      textDecoration: 'none',
      color: '#ffffff',
      backgroundColor: '#000000',
      padding: '10px 25px',
      borderRadius: '50px', // Pill shape
      fontWeight: 'bold',
      textTransform: 'uppercase',
      fontSize: '0.8rem',
      whiteSpace: 'nowrap', // Prevents the text from breaking
    }
  };

  return (
    <header style={styles.header}>
      {/* Left: Logo */}
      <a href="#">
        <img src={logoUrl} alt="Company Logo" style={styles.logo} />
      </a>

      {/* Center: Navigation Menu */}
      <nav style={styles.nav}>
        <ul style={styles.navList}>
          {navLinks.map(link => (
            <li
              key={link}
              style={
                activeLink === link
                  ? { ...styles.navItem, ...styles.activeNavItem }
                  : styles.navItem
              }
              onClick={() => setActiveLink(link)}
            >
              <a href="#" style={styles.navLink}>
                {link}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      {/* Right: Book Now Button */}
      <a href="#" style={styles.bookNowButton}>
        Book Now
      </a>
    </header>
  );
};

export default TemplateHeader2;